import {
    GET_POWERPOINT_REPORT,
    FETCH_POWERPOINT_REPORT,
    DELETE_POWERPOINT_REPORT,
    CREATE_POWERPOINT_REPORT,
    GET_POWERPOINT_REPORT_STATUS,
    CLEAR_POWERPOINT_REPORT,
    POWERPOINT_REPORTS_PENDING,
  } from "constants/actions";
  
  const initialState = {
    reports: [],
    reportDetails: null,
    status: null,
    pending: false,
  };
  
  export default function presentationReportReducer(state = initialState, action) {
    switch (action.type) {
      case POWERPOINT_REPORTS_PENDING:
        return { ...state, pending: true };
  
      case GET_POWERPOINT_REPORT:
        return { ...state, reports: action.payload, pending: false };
        
        case FETCH_POWERPOINT_REPORT:
        return { ...state, reportDetails: action.payload, pending: false };
      case CREATE_POWERPOINT_REPORT:
        return { ...state, reportDetails: action.payload, pending: false };
  
      case DELETE_POWERPOINT_REPORT:
        return {
          ...state,
          reports: state.reports.filter((report) => report.id !== action.payload),
          pending: false,
        };
  
      case GET_POWERPOINT_REPORT_STATUS:
        return { ...state, status: action.payload, pending: false };
  
      case CLEAR_POWERPOINT_REPORT:
        return { ...state, reportDetails: null, status: null };
  
      default:
        return state;
    }
  }